"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deleteProject = void 0;
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const ActionTypes = require("../../actionTypes/project/delete");
const ListActions = require("../../actions/projects");
const Actions = require("../../actions/project/delete");
const errorHandling_1 = require("../../utils/errorHandling");
function deleteProject(action$, store, { ajax, getToken, baseUrl }) {
    return action$.pipe((0, operators_1.filter)((action) => action.type === ActionTypes.DELETE_PROJECT_REQUEST), (0, operators_1.mergeMap)((action) => ajax({
        headers: {
            'Content-Type': 'application/json',
            Authorization: getToken()
        },
        method: 'DELETE',
        url: `${baseUrl}api/admin/project/${action.payload.id}`
    }).pipe((0, operators_1.mergeMap)(() => {
        const acts = [
            Actions.deleteProjectSuccess(),
            ListActions.fetchProjects()
        ];
        return (0, rxjs_1.of)(...acts);
    }), (0, operators_1.catchError)((error) => (0, rxjs_1.of)(Actions.deleteProjectFailure((0, errorHandling_1.parseAjaxErrorResponse)(error)))))));
}
exports.deleteProject = deleteProject;
//# sourceMappingURL=delete.js.map